module.exports = __webpack_public_path__ + "static/img/lniao_header_bg.fe0ac8e3.png";